declare global {
  interface HTMLElementTagNameMap {
    "cart-size-modal": CartSizeModal;
  }
}

class CartSizeModal extends HTMLElement {
  private overlay: HTMLElement | null = null;
  private closeButton: HTMLElement | null = null;
  private continueButton: HTMLElement | null = null;
  private sizeGuideButton: HTMLElement | null = null;

  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.key === "Escape" && this.isOpen) {
      this.close();
    }
  };

  connectedCallback(): void {
    this.overlay = this.querySelector("[data-cart-size-modal-overlay]");
    this.closeButton = this.querySelector("[data-cart-size-modal-close]");
    this.continueButton = this.querySelector("[data-cart-size-modal-continue]");
    this.sizeGuideButton = this.querySelector(
      "[data-cart-size-modal-size-guide]",
    );

    this.overlay?.addEventListener("click", (e) => {
      e.stopPropagation();
      this.close();
    });
    this.closeButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    });
    this.continueButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    });
    this.sizeGuideButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openSizeGuide();
    });

    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("cart:added", this.onCartAdded);

    if (document.body.classList.contains("template-cart")) {
      this.checkCart();
    }
  }

  disconnectedCallback(): void {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("cart:added", this.onCartAdded);
  }

  private onCartAdded = (): void => {
    this.checkCart();
  };

  get isOpen(): boolean {
    return this.classList.contains("is-open");
  }

  open(): void {
    this.classList.add("is-open");
  }

  close(): void {
    this.classList.remove("is-open");
  }

  private openSizeGuide(): void {
    this.close();
    document.body.removeAttribute("data-cart-active");

    const drawer = document.querySelector("size-chart-drawer") as
      | (HTMLElement & { open?: () => void })
      | null;
    drawer?.open?.();
  }

  /**
   * The condition is computed in Liquid and published on the cart drawer as
   * `data-multi-size`, so this no longer costs a `/cart.js` request per add.
   * The drawer is re-rendered before `cart:added` fires, so the attribute is
   * already current by the time this reads it.
   */
  private checkCart(): void {
    const drawer = document.querySelector<HTMLElement>("cart-drawer");
    if (drawer?.dataset.multiSize === "true") this.open();
  }
}

if (!window.customElements.get("cart-size-modal")) {
  window.customElements.define("cart-size-modal", CartSizeModal);
}

export { CartSizeModal };
